export default {
  PLN: "PLN",
  USD: "USD",
  EUR: "EUR",
};
